export default __webpack_public_path__ + "static/media/splat.9269c02f.mp3";